
import abImg1 from '../../images/about/1.jpeg'
import abImg2 from '../../images/about/award-icon-2.svg'
// import Signeture from '../../images/about/signeture.png'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const About = (props) => {

    return (
        <section className="about-section section-padding container">
            <div className="container mb-lg-5">
                <div className="row align-items-center">
                    <div className="col-xl-6 col-12">
                        <div className="about-left-content">
                            <div className="image">
                                <img src={abImg1} alt="" />
                            </div>
                            <div className="award-content">
                                <div className="icon" >
                                    <img src={abImg2} alt="" />
                                </div>
                                
                                <h2>Your  <span className='text-warning'>Vision,</span> Our Innovation</h2>
                                {/* <p style={{textAlign:'justify'}}>We have a history of successfully delivering IT solutions to a great diverse clientele, from startups to established enterprises.</p> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-12">
                        <div className="about-right-content">
                            <h2 className="title">ABOUT COMPANY</h2>
                            <h3 className="sub-title">Our approach ensures flexibility, adaptability, & rapid response.</h3>
                            <p className="text-justify" style={{textAlign:'justify'}}>Welcome to THINKBIG INFOTECH, where innovation meets implementation to transform ideas into powerful digital solutions.
                                We specialize in next-gen technologies, helping businesses embrace digital transformation with confidence.
                                Our services include Mobile App Development, Web App Development, UI/UX Design, Cloud Infrastructure, IT Staffing, and Offshore Development.
                                We deliver scalable, user-centric, and cost-effective solutions tailored to your unique business needs.
                                With a passionate team and a commitment to quality, we build future-ready digital experiences that drive growth.
                                <span>Our mission is clear to provide comprehensive and customized IT solution that
                                    align seamlessly with your business objectives. We believe in not just meeting but
                                    exceeding expectations.</span>
                            </p>

                        </div>
                    </div>
                </div> 
            </div>
            {/* <div className="shape-1">
                <svg width="429" height="593" viewBox="0 0 429 593" fill="none">
                    <circle cx="296.5" cy="296.5" r="296.5" fill="url(#cc318_1506)" />
                    <defs>
                        <radialGradient id="cc318_1506" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(296.5 296.5) rotate(90) scale(296.5)">
                            <stop offset="0" stopColor="#CED0FF" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </radialGradient>
                    </defs>
                </svg>
            </div>
            <div className="shape-2">
                <svg width="529" height="529" viewBox="0 0 529 529" fill="none">
                    <circle cx="264.5" cy="264.5" r="264.5" fill="url(#oo1508)" />
                    <defs>
                        <radialGradient id="oo1508" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(264.5 264.5) rotate(90) scale(264.5)">
                            <stop offset="0" stopColor="#FBB132" stopOpacity="0.2" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </radialGradient>
                    </defs>
                </svg>
            </div> */}
        </section>
    )
}

export default About;



